import type { ReactNode } from 'react';

export const symbol_desktop_access_disabled: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m140-840 60 60h-60v480h455L49-845q-9-9-8.5-21.5T50-888q9-9 21-9t21 9l748 747q9 9 9 21t-9 21q-9 9-21.5 9T797-99L655-240H540v100h56q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q608.75-80 596-80H364q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h56v-100H140q-24 0-42-18t-18-42v-480q0-24 18.5-42t41.5-18Zm741 60v474q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-474H326q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T326-840h495q23 0 41.5 18.5T881-780ZM553-512Zm-185-15Z"
		/>
	</svg>
);
